"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentEntitySchema = void 0;
exports.documentEntitySchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'documentLink',
        'documentStatus',
        'fileName',
        'fileSize',
        'fileType',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'uniqueFileName',
    ],
    properties: {
        acl: {
            type: ['array', 'null'],
            items: {
                type: 'string',
                format: 'uuid',
            },
            errorMessage: 'Should be an array of UUIDv4s or null',
        },
        associationId: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        defaultApplicationId: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 50,
            errorMessage: 'should have variable length up to 50 characters or null',
        },
        description: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 150,
            errorMessage: 'should have variable length up to 150 characters or null',
        },
        documentLink: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 500,
            errorMessage: 'should have variable length up to 500 characters',
        },
        documentType: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        documentStatus: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        fileName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should have variable length up to 100 characters',
        },
        fileSize: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        fileType: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        uniqueFileName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should have variable length up to 100 characters',
        },
    },
};
